// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"64824d71","296":"672cd3e8","338":"1fe036be","386":"800689f5","430":"9dd4b0bb","456":"1295bdc2","790":"f5c3b420"}[chunkId] + ".chunk.css";
};